// Match the screen example without generating or replacing a server answer.
export const ETCH_SCENARIO_ID = 'etch-equipment';
export const ETCH_SCENARIO_QUESTIONS = [
    '식각 공정에 사용하는 장비 목록을 보여줘',
    '실리콘 식각 장비를 선택해서 목록을 보여줘',
    '저 중에서 CMOS etcher를 보여줘',
    '저 중에서 프로파일 Y, Z축 값이랑 압력값, 온도값을 보여줘'
];
export const ETCH_SCENARIO_SCREENS: { [screen: number]: { src: string; label: string; description: string } } = {
    1: { src: '/assets/chatbot/etch-scenario/etch-equipment-1.png', label: '식각 장비 1.png', description: '식각 장비 전체 목록' },
    2: { src: '/assets/chatbot/etch-scenario/etch-equipment-2.png', label: '식각 장비 2.png', description: '실리콘 식각 장비의 하위 공정 목록' },
    3: { src: '/assets/chatbot/etch-scenario/etch-equipment-3.png', label: '식각 장비 3.png', description: 'CMOS Etcher 선택' },
    4: { src: '/assets/chatbot/etch-scenario/etch-equipment-4.png', label: '식각 장비 4.png', description: 'CMOS Etcher 전체 속성 목록' },
    7: { src: '/assets/chatbot/etch-scenario/etch-equipment-7.png', label: '식각 장비 7.png', description: '프로파일 Y·Z, 압력, 온도 값' }
};

/** Recognize only the selected four-question flow in this conversation. */
export function getEtchScenarioStep(question: string, previousStep: number): number {
    if (typeof question !== 'string' || question.length > 2000) return 0;
    if (!Number.isInteger(previousStep) || previousStep < 0 || previousStep > 4) previousStep = 0;
    const normalized = question.toLowerCase().replace(/[.,!?。？！]/g, '').replace(/\s+/g, '').trim();
    if (normalized === '식각공정에사용하는장비목록을보여줘') return 1;
    if (previousStep >= 1 && normalized === '실리콘식각장비를선택해서목록을보여줘') return 2;
    if (previousStep >= 2 && normalized === '저중에서cmosetcher를보여줘') return 3;
    if (previousStep >= 3 && normalized === '저중에서프로파일yz축값이랑압력값온도값을보여줘') return 4;
    return 0;
}

/** Screen navigation metadata only; answer content comes from the normal pipeline. */
export function getEtchScenarioMetadata(step: number) {
    if (![1, 2, 3, 4].includes(step)) return null;
    const screenSequence = step === 3 ? [3, 4] : [step === 4 ? 7 : step];
    return {
        id: ETCH_SCENARIO_ID, step, screenSequence, referenceKind: 'attachment',
        referenceLabel: ETCH_SCENARIO_SCREENS[screenSequence[screenSequence.length - 1]].label,
        selectedAttributes: step === 4 ? ['PROF_Y_VAL', 'PROF_Z_VAL', 'PRES_VAL', 'TEMP_VAL'] : []
    };
}

/** Bounded public completion payload; excludes credentials, bindings and raw tool records. */
export function publicFloatingChatCompletion(event: any) {
    if (!event || typeof event.question !== 'string' || typeof event.requestId !== 'string'
        || !/^req-[0-9a-f]{32}$/.test(event.requestId)) return null;
    const result = event.result || {};
    const answer = result.answer || result.content || result.reply;
    if (typeof answer !== 'string' || !answer.trim()) return null;
    const scenario = result.scenario?.id === ETCH_SCENARIO_ID
        ? getEtchScenarioMetadata(result.scenario.step) : null;
    return {
        requestId: event.requestId, question: event.question.slice(0, 2000), answer: answer.slice(0, 8000), kind: scenario ? 'data' : 'answer',
        source: String(result.source || '').slice(0, 80),
        dataScope: String(result.dataScope || '').slice(0, 60),
        intent: String(result.intent || result.analysis?.intent || '').slice(0, 80),
        ...(scenario ? { scenario } : {})
    };
}
